import styled from '@emotion/styled';
import { rgba } from 'polished';
import React from 'react';
import type { InputSize, InputVariant } from '../Input';
import { Input } from '../Input';
import { NumberFormatInput } from './NumberFormatInput';

const Host = styled.div``;

/*const Input = styled.input`
  width: 44px;
  text-align: center;
  ${typography.input2};
  padding-top: 5px;
`;*/

const MinusButton = styled.button`
  border: 1px solid ${(props) => rgba(props.theme.colors.primary, 0.3)};
  border-radius: 100px;
  height: 30px;
  width: 30px;
  color: transparent;
  display: inline-block;
  position: absolute;
  cursor: pointer;
  left: 20px;
  top: 50%;
  z-index: 10;
  cursor: pointer;

  &::after {
    content: '';
    display: block;
    border-bottom: 1px solid ${(props) => rgba(props.theme.colors.primary, 0.3)};
    position: absolute;
    top: 50%;
    left: calc(50% - 4px);
    width: 9px;
  }
`;

const PlusButton = styled(MinusButton)`
  left: initial;
  right: 20px;
  &::before {
    content: '';
    display: block;
    border-bottom: 1px solid ${(props) => rgba(props.theme.colors.primary, 0.3)};
    position: absolute;
    top: 50%;
    left: calc(50% - 4px);
    width: 9px;
    transform: rotate(90deg);
  }
`;

export const NumberHost = styled.div`
  position: relative;
`;

export interface IProps {
  allowNegatives?: boolean;
  value: number;
  onChange: (val: number) => void;
  label: string;
  id: string;
  inputSize?: InputSize;
  variant?: InputVariant;
}

export function NumberInput({
  allowNegatives,
  onChange,
  value,
  ...rest
}: IProps) {
  function changeValue(newVal: number) {
    if (allowNegatives || newVal >= 0) {
      onChange(newVal);
    }
  }
  return (
    <Host>
      <NumberHost>
        <MinusButton
          onClick={(e) => {
            e.preventDefault();
            const nn = value - 1;
            if (allowNegatives || nn >= 0) {
              changeValue(nn);
            }
          }}
        >
          -
        </MinusButton>
        <NumberFormatInput
          customInput={Input}
          displayType="input"
          allowEmptyFormatting
          value={value}
          textAlign="center"
          labelVariant="aboveInput"
          variant="noBorder"
          onValueChange={(values) => {
            if (values.floatValue !== undefined && values.floatValue > -1) {
              changeValue(values.floatValue);
            }
          }}
          {...rest}
        />
        <PlusButton
          onClick={(e) => {
            e.preventDefault();
            changeValue(value + 1);
          }}
        >
          +
        </PlusButton>
      </NumberHost>
    </Host>
  );
}
